// extracted by mini-css-extract-plugin
export default {"Box":"archive-list-item-module__Box--xNlEn"};